<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE TIPO DE VISITAS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-show="form.visitName.required" class="text-danger">*</small>Tipo de Visitas:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Tipo da Visita'"
                          v-model="form.visitName.value"
                          :size="form.visitName.maxlength"
                          :required="form.visitName.required"
                          :state="form.visitName.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import VisitTypeModel from '@/shared/models/configurations/visittypemodel.js'
import VisitTypeForm from './visit-type-form.js'
import VisitTypeRepository from '@/shared/http/repositories/configurations/visittype.js'

export default {
  name: 'VisitTypeAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: VisitTypeModel,
      form: VisitTypeForm
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onCreate () {
      loading.push()
      VisitTypeRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      VisitTypeRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visitas/visit-type/components/add/visittypeadd.vue